/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';
import React from 'react';

import { Button, Spacer, TranslationProvider } from '@resy/ui-kitchen';
import ModalMessages from '../ModalMessages';

const renderCancel = (
  cancelClick,
  cancelKey,
  cancelText,
  cancelButtonVariant
) => {
  if (!cancelClick) {
    return null;
  }

  return (
    <>
      <Spacer height="10" />
      <TranslationProvider translationKey={cancelKey || 'button_cancel'}>
        <Button onClick={cancelClick} variant={cancelButtonVariant} data-test-id="modal-button-cancel">
          {cancelText || 'Cancel'}
        </Button>
      </TranslationProvider>
    </>
  );
};

const ConfirmCancel = ({
  cancelButtonVariant,
  cancelClick,
  cancelCtaKey,
  cancelCtaText,
  children,
  confirmButtonVariant,
  confirmClick,
  confirmCtaKey,
  confirmCtaText,
}) => (
  <ModalMessages className="ConfirmCancel">
    {children}
    <Spacer height="35" />
    <TranslationProvider translationKey={confirmCtaKey || 'button_confirm'}>
      <Button onClick={confirmClick} data-test-id="modal-button-confirm" variant={confirmButtonVariant}>
        {confirmCtaText || 'Confirm'}
      </Button>
    </TranslationProvider>
    {renderCancel(cancelClick, cancelCtaKey, cancelCtaText, cancelButtonVariant)}
  </ModalMessages>
);

ConfirmCancel.propTypes = {
  cancelButtonVariant: PropTypes.string,
  cancelClick: PropTypes.func,
  cancelCtaKey: PropTypes.string,
  cancelCtaText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
  confirmButtonVariant: PropTypes.string,
  confirmClick: PropTypes.func,
  confirmCtaKey: PropTypes.string,
  confirmCtaText: PropTypes.string,
};

ConfirmCancel.defaultProps = {
  cancelButtonVariant: 'secondary',
  cancelClick: undefined,
  cancelCtaKey: undefined,
  cancelCtaText: undefined,
  children: undefined,
  confirmButtonVariant: 'primary',
  confirmClick: undefined,
  confirmCtaKey: 'button_confirm',
  confirmCtaText: 'Confirm',
};

export default ConfirmCancel;
